export const getFileNameFromPath = (path = ''): string => {
  const url = path.split('?')[0]; // remove params and utm tags

  const fileNameParts = url.split('/');

  return fileNameParts[fileNameParts.length - 1];
};
